import React from "react";
import { Avatar, Button, Icon, Tooltip } from "@alpaca/framework";
import { checkPermission } from "../../service/permission/permission";
import EditInvitationButton from "../../components/editInvitation/editInvitation.component";
export function UserCard({
  name,
  email,
  profileName,
  onEdit,
  onImpersonate,
  pending,
  setShowCancel,
  setCurrentRecord,
  setShowForceCreate,
  setShowResend,
  record,
}) {
  return (
    <div className={`userCardContainer ${pending ? "pending" : ""}`}>
      <div className="userCardAvatarContainer">
        <Avatar name={name} size={"large"} />
      </div>
      <h3 className="bodyTextLarge textCentre">{name}</h3>

      {pending && <div className="userCardPending">Pending Invite</div>}
      <div className="userCardDetails">
        {email && (
          <a href={`mailto:${email}`}>
            <p className="bodyTextSmall linkText">{email}</p>
          </a>
        )}

        {profileName && <p className="bodyTextSmall">{profileName}</p>}
      </div>
      <div className="userCardActions">
        {!checkPermission("modify user") ? (
          <></>
        ) : pending ? (
          <EditInvitationButton
            showCancelModal={() => {
              setShowCancel(true);
              setCurrentRecord(record);
            }}
            showResendModal={() => {
              setShowResend(true);
              setCurrentRecord(record);
            }}
            showForceCreateModal={() => {
              setShowForceCreate(true);
              setCurrentRecord(record);
            }}
          ></EditInvitationButton>
        ) : (
          <Button onClick={onEdit} className="userCardButton">
            Edit User
          </Button>
        )}

        {checkPermission("impersonate user") && !pending && (
          <Tooltip title="View as">
            <Button
              icon={
                <Icon
                  style={{
                    marginTop:
                      "4px" /**gross fix because ANTD forces 4 padding bottom which screws up alignment. */,
                  }}
                  onClick={onImpersonate}
                  icon="show"
                />
              }
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
}
